.scoreBox {
    background-color: green;
    border-radius: 20px;
    border: 1px solid white;
    height: 42px;
    padding: 5px 0px;
    transform: scale(0.8);
    transition: all 0.2s ease;
}

.icon {
    font-size: 20px;
    color: white;
    transform: scale(1.5);
    margin-left: 10px;
    width: 32px;
}

.text {
    color: white;
    font-size: 20px;
    font-weight: 600;
    margin-right: 6px;
    white-space: nowrap;
}

.numberScore {
    border: none;
    margin: 6px;
    border-radius: 20px;
    background-color: white !important;
    width: 40px;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    opacity: 1;
}
